import { z } from 'zod';
import type { RegionPartsFragment } from '~/apollo/generated/v3/graphql';
import { rejectNil } from '~/utils/common';
import { ppStringOrNull } from '~/utils/zod';

// Hide the map for these regions
// https://github.com/omt-tech/safari/issues/1953
export function isGlobalRegion(region: {
  location: Pick<RegionPartsFragment['location'], 'country'>;
}) {
  return region.location.country === 'Unassigned';
}

export function locationString(location: RegionPartsFragment['location']) {
  return [location.location, location.country].filter(rejectNil).join(', ');
}

export const regionSchema = z.object({
  name: z.string(),
  description: z.string(),
  basins: z.preprocess(ppStringOrNull, z.string().nullable()),
  location: z.string(),
  country: z.string(),
});

export type RegionFormValues = {
  name: string;
  description: string;
  basins: string;
  country: string;
  location: string;
};

export const initialRegion = (
  region?: RegionPartsFragment,
): RegionFormValues => ({
  name: region?.name ?? '',
  description: region?.description ?? '',
  basins: region?.basins ?? '',
  country: region?.location?.country ?? '',
  location: region?.location?.location ?? '',
});
